import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './radio.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';
import { notNullOrUndefinedCheck } from '../../../utils/common';


class RadioGroup extends Component {

    state = {
        label: notNullOrUndefinedCheck(this.props.initialValues.label, 'Radio group label'),
        required: this.props.initialValues.isRequired || false,
        multiple: this.props.initialValues.multiple || false,
        radioData: [],
        name: RadioGroup.generateId(),
        requiredError: !!this.props.initialValues.isRequired,
    };

    static generateId() {
        return 'radio-'+String( Date.now() ) + `f${(~~(Math.random()*1e8)).toString(16)}`;
    };

    updateInputPropsInStore = () => {
        const { label, multiple, required, radioData } = this.state;

        const inputProps = {
            type: this.props.initialValues.type,
            multiple,
            label,
            isRequired: required,
            options: radioData.map(el => el.name),
            _value: radioData.map(el => ({
                name: el.name.toLowerCase() === 'other' ? el.name + `(${el.otherOption})` : el.name,
                checked: String(el.checked === 'checked')
            })),
            _hasValidationErrors: this.state.requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);

        this.initRadioData(this.props.initialValues.options || ['Apple', 'Other']);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    initRadioData = (options) => {
        const data = options.map(name => ({ id: RadioGroup.generateId(), name, checked: '', otherOption: '' }));
        this.setState({ radioData: data });
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    };

    addRadio = () => {
        this.setState({
            radioData: [...this.state.radioData, {
                id: RadioGroup.generateId(),
                name: 'default value',
                checked: '',
                otherOption: ''
            }]
        });
    };

    editRadio = (e, key, target = 'name') => {
        let newRadioData = [...this.state.radioData].map((item, index) => {
            if (key === index) {
                item[target] = e.target.value;
                item.id = RadioGroup.generateId()
            }

            return item
        });

        this.setState({ radioData: newRadioData });
    };

    removeRadio = (key) => {
        let filtered = [...this.state.radioData].filter((item, index) => (
            key !== index
        ));

        this.setState({ radioData: filtered })
    };

    onCheck = (e) => {
        let newRadioData = this.state.radioData.map(item => {
            item.checked = item.id === e.target.id ? 'checked' : '';
            return item
        });

        this.setState({
            radioData: newRadioData,
            requiredError: this.updateRequiredError(newRadioData)
        })
    };

    onMultipleCheck = (e) => {
        let newRadioData = this.state.radioData.map(item => {
            if (item.id === e.target.id) {
                item.checked = e.target.checked ? 'checked': '';
            }
            return item
        });

        this.setState({
            radioData: newRadioData,
            requiredError: this.updateRequiredError(newRadioData)
        });
    };

    updateRequiredError = (newRadioData) => {
        return this.state.required ?  newRadioData.findIndex(el => el.checked === 'checked') === -1: false;
    };

    setSelectType = (e) => {
        const newRadioData = [...this.state.radioData].map((item) => {
            item.checked = '';
            return item;
        });

        this.setState({ multiple: e.target.value === 'true', radioData: newRadioData })
    };

    render() {
        const { color, textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    labelFontSize={'18px'}
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    {
                        this.state.radioData.map((item, index) => (
                            <div key={index} className="radio-wrapper">
                                {
                                    this.state.multiple ?
                                        <input
                                            id={item.id}
                                            onChange={this.onMultipleCheck}
                                            checked={item.checked === 'checked'}
                                            type="checkbox"
                                            name={this.state.name}
                                            className={`round-radio ${item.name}`}
                                        />
                                        :
                                        <input
                                            id={item.id}
                                            checked={item.checked === 'checked'}
                                            onChange={this.onCheck}
                                            type="radio"
                                            name={this.state.name}
                                            className={`round-radio ${item.name}`}
                                        />
                                }

                                <label htmlFor={item.id}>
                                    { item.name }
                                    <span style={{ backgroundColor: color }} className="custom-radio"/>
                                    {
                                        item.name.toLowerCase() === 'other' && item.checked &&
                                        <input
                                            value={item.otherOption}
                                            onChange={(e) => this.editRadio(e, index, 'otherOption')}
                                            type="text"
                                            placeholder="Type other option..."
                                            className="radio-other_input"
                                        />
                                    }
                                </label>
                            </div>
                        ))
                    }
                </AppInputWrapper>

                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>

                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>

                            <label>
                                <select value={this.state.multiple} onChange={this.setSelectType} >
                                    <option value={false}>Single</option>
                                    <option value={true}>Multiple</option>
                                </select>

                            </label>

                            <div className="new-radios-container">
                                Options:
                                {this.state.radioData.map((item, index) => (
                                    <div key = {index} style={{ 'width': '100%' }}>
                                        {index + 1})
                                        <input
                                            onChange={(e) => {this.editRadio(e, index)}}
                                            type="text"
                                            value={item.name}
                                        />
                                        <button onClick={() => {this.removeRadio(index)}}>
                                            <i className="fa fa-trash" aria-hidden="true"/>
                                        </button>
                                    </div>
                                ))}
                                <button
                                    className="btn btn-primary"
                                    onClick={this.addRadio}
                                >add a radio button</button>
                            </div>

                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(RadioGroup);
